import React from 'react';
import './header.css';

const Header = () => {
  return (
    <div className=" dashboard-head">Welcome To The Dashboard Of MSI</div>
  );
};

export default Header;